"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.panelDarkTheme = exports.panelClassicTheme = exports.panelThemeNamespace = exports.defaultMaxHeight = exports.baseDefaultHeight = exports.defaultMaxWidth = exports.baseDefaultWidth = void 0;

var _theme = require("@tablekit/theme");

var baseDefaultWidth = 360;
exports.baseDefaultWidth = baseDefaultWidth;
var defaultMaxWidth = 1000;
exports.defaultMaxWidth = defaultMaxWidth;
var baseDefaultHeight = 360;
exports.baseDefaultHeight = baseDefaultHeight;
var defaultMaxHeight = 1000;
exports.defaultMaxHeight = defaultMaxHeight;
var panelThemeNamespace = '@tablekit/panel';
exports.panelThemeNamespace = panelThemeNamespace;
var panelClassicTheme = {
  backgroundColor: (0, _theme.color)('surface'),
  borderColor: (0, _theme.color)('border'),
  borderColorHover: (0, _theme.color)('primary')
};
exports.panelClassicTheme = panelClassicTheme;
var panelDarkTheme = panelClassicTheme;
exports.panelDarkTheme = panelDarkTheme;